import { render, staticRenderFns } from "./CategoryListForm.vue?vue&type=template&id=8327795e"
import script from "./CategoryListForm.vue?vue&type=script&lang=js"
export * from "./CategoryListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports